/**
 * 구독 서비스 이용약관 요약 — 동의 체크 바로 위에 보이는 목록. 로그인한 결제 화면(`OfferCard`)과
 * 결제 링크 화면(`/pay`)이 같이 쓴다 (261020-pay-link). 문안은 `SUBSCRIPTION_TERMS_SUMMARY` 한 곳이다
 */
import { SUBSCRIPTION_TERMS_SUMMARY } from '../legal/content/subscription.ts';

const won = (n: number) => `${n.toLocaleString('ko-KR')}원`;

/** 결제 일정 문구 — 약관 요약의 `{schedule}`. 개시일이 있으면 그 일(日)이 구독일이다 */
const scheduleText = (startOn: string | null) =>
  startOn ? `매월 ${Number(startOn.slice(8, 10))}일(구독 개시일 ${startOn} 기준)에` : '매월 같은 날';

export interface TermsSubject {
  brandName: string;
  /** 묶인 질문 — 없으면 질문 줄을 뺀다 */
  query: string | null;
  amountKrw: number;
  startOn: string | null;
}

function line(t: string, s: TermsSubject) {
  return t.split(/(\{\w+\})/).map((part, i) => {
    const key = `${i}${part}`;
    if (part === '{query}')
      return (
        <b key={key} className="text-slate-900">
          {s.query}
        </b>
      );
    if (part === '{brand}')
      return (
        <b key={key} className="text-slate-900">
          {s.brandName}
        </b>
      );
    if (part === '{amount}') return won(s.amountKrw);
    if (part === '{schedule}') return scheduleText(s.startOn);
    return part;
  });
}

export function TermsSummary({ subject }: { subject: TermsSubject }) {
  return (
    <ul className="grid gap-2 text-slate-700">
      {SUBSCRIPTION_TERMS_SUMMARY.filter((t) => subject.query || !t.includes('{query}')).map((t) => (
        <li key={t} className="flex gap-2">
          <span className="mt-[7px] h-1 w-1 shrink-0 rounded-full bg-slate-400" />
          <span>{line(t, subject)}</span>
        </li>
      ))}
    </ul>
  );
}
